// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1wxHK","additionalInfo":"AgreementModal_additionalInfo__3t-x5"};